import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import CgButton from 'modules/Common/ui/CgButton';

const PermissionDenied = ({ requiredPermission }) => {
  const { t } = useTranslation('common');
  const history = useHistory();

  const handleGoBack = () => {
    history.goBack();
  };

  const handleGoDashboard = () => {
    history.push('/init');
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <div className="text-center">
        <FontAwesomeIcon
          icon={faLock}
          size="4x"
          className="text-red-500 mb-6"
        />
        <h1 className="text-4xl font-bold text-gray-800 mb-4">
          {t('common:permissionDenied.accessDenied', 'Access Denied')}
        </h1>
        <p className="text-lg text-gray-600 mb-2">
          {t(
            'common:permissionDenied.noPermissionBody',
            'You do not have permission to access this page.',
          )}
        </p>
        {requiredPermission && (
          <p className="text-sm text-gray-500 mb-6">
            {t('common:permissionDenied.requiredPermissionLabel', 'Required permission:')}{' '}
            <code className="bg-gray-200 px-2 py-1 rounded">{requiredPermission}</code>
          </p>
        )}
        <div className="flex gap-3 justify-center">
          <CgButton
            size="lg"
            variant="secondary"
            label={t('common:actions.goBack', 'Go Back')}
            onClick={handleGoBack}
          />
          <CgButton
            size="lg"
            variant="primary"
            label={t('common:actions.goToDashboard', 'Go to dashboard')}
            onClick={handleGoDashboard}
          />
        </div>
      </div>
    </div>
  );
};

export default PermissionDenied;
